// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   TextField,
//   Avatar,
//   Button,
//   Grid,
//   IconButton,
//   Divider,
//   Alert,
//   CircularProgress,
//   Stack,
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
// import chatApi from './ChatApi';
// import { chatPhotoUrl, uploadedFileUrl } from '../../utils/constants/links';
// import { useDispatch } from 'react-redux';
// import { commonFileUpload } from '../../redux/features/assetManagementSlice';
// import ChatCreation from './ChatCreation';

// const GroupDetails = ({ chatDetails }) => {
//   const chatRoomId = chatDetails?.chat_room_id;
//   const dispatch = useDispatch();
//   const [pageType, setPageType] = useState('grpDetails');
//   const [allData, setAllData] = useState(null);
//   const [groupName, setGroupName] = useState('');
//   const [description, setDescription] = useState('');
//   const [avatar, setAvatar] = useState(null);
//   const [members, setMembers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [userIds, setUserIds] = useState([]);

//   const [alert, setAlert] = useState({
//     open: false,
//     message: '',
//     severity: 'success',
//   });

//   useEffect(() => {
//     getGroupInfoDetails();
//   }, []);

//   const showAlert = (message, severity = 'success') => {
//     setAlert({ open: true, message, severity });
//     setTimeout(() => setAlert({ ...alert, open: false }), 4000);
//   };

//   const getGroupInfoDetails = async () => {
//     const res = await chatApi.getGroupInfo(chatRoomId);
//     const data = res?.data;
//     if (data) {
//       setAllData(data);
//       const ids = data.chatRoomMembers.map((member) => member.user);
//       setUserIds(ids); // ✅ persist across renders

//       console.log(ids);
//       setGroupName(data.name);
//       setDescription(data.description);
//       setAvatar(data.profile_pic);
//       setMembers(data.chatRoomMembers);
//     }
//   };

//   const uploadFile = async (e) => {
//     try {
//       setLoading(true);
//       const file = e.target.files[0];
//       const formData = new FormData();
//       formData.append('uploads', file);
//       const response = await dispatch(commonFileUpload(formData));
//       setAvatar(response.payload?.data?.filename || null);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const removeMember = async (userId) => {
//     await chatApi.removeMemberFromGroup(chatRoomId, userId);
//     showAlert('Member removed successfully');
//     getGroupInfoDetails();
//   };

//   const onSaveClicked = async () => {
//     console.log(avatar);
//     setLoading(true);
//     await chatApi.updateGroup({
//       chatRoomId,
//       groupName,
//       profile_pic: avatar,
//       description,
//     });
//     setLoading(false);
//     showAlert('Group details updated successfully');
//     getGroupInfoDetails();
//   };

//   return pageType === 'grpDetails' ? (
//     <Box height="100vh" display="flex" justifyContent="center" alignItems="stretch" bgcolor="#f4f6f8" pb={5}>
//       <Card
//         sx={{
//           width: 900,
//           height: '100%',
//           display: 'flex',
//           flexDirection: 'column',
//           borderRadius: 3,
//         }}
//       >
//         {/* HEADER */}
//         <Box p={3} bgcolor="#f3e5f5">
//           <Stack direction="row" spacing={3} alignItems="center">
//             <Box position="relative">
//               <Avatar src={`${uploadedFileUrl}/${avatar}`} sx={{ width: 90, height: 90 }} />
//               <label htmlFor="group-avatar">
//                 <input hidden id="group-avatar" type="file" onChange={uploadFile} />
//                 <IconButton
//                   component="span"
//                   sx={{
//                     position: 'absolute',
//                     bottom: -5,
//                     right: -5,
//                     bgcolor: '#fff',
//                     boxShadow: 1,
//                   }}
//                 >
//                   <AddAPhotoIcon />
//                 </IconButton>
//               </label>
//             </Box>

//             <Box flex={1}>
//               <TextField
//                 variant="standard"
//                 fullWidth
//                 value={groupName}
//                 onChange={(e) => setGroupName(e.target.value)}
//                 InputProps={{ sx: { fontSize: 24, fontWeight: 600 } }}
//               />
//               <Typography variant="caption" color="text.secondary">
//                 Created by <b>{allData?.createdBy}</b> • {allData?.created_at}
//               </Typography>
//             </Box>
//           </Stack>
//         </Box>

//         {/* SCROLLABLE CONTENT */}
//         <CardContent sx={{ flex: 1, overflowY: 'auto' }}>
//           {alert.open && (
//             <Alert severity={alert.severity} sx={{ mb: 2 }}>
//               {alert.message}
//             </Alert>
//           )}

//           {/* DESCRIPTION */}
//           <Typography fontWeight={600}>Description</Typography>
//           <TextField
//             fullWidth
//             multiline
//             rows={3}
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             sx={{ mt: 1, bgcolor: '#fff' }}
//           />

//           <Divider sx={{ my: 3 }} />

//           {/* MEMBERS */}
//           {/* <Typography variant="h6" mb={2}>
//             Members ({members.length})
//           </Typography> */}
//           <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
//             <Typography variant="h6">Members ({members.length})</Typography>

//             <IconButton color="primary" onClick={() => setPageType('add_to_group')}>
//               <AddIcon />
//             </IconButton>
//           </Box>

//           <Grid container spacing={2}>
//             {members.map((member) => (
//               <Grid item xs={12} key={member.user}>
//                 <Card
//                   variant="outlined"
//                   sx={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     p: 2,
//                     borderRadius: 2,
//                   }}
//                 >
//                   <Avatar src={`${chatPhotoUrl}/${member.photo}.jpg`} sx={{ mr: 2 }}>
//                     {member.name?.charAt(0)}
//                   </Avatar>

//                   <Box flex={1}>
//                     <Typography fontWeight={600} fontSize={14}>
//                       {member.name}
//                       {member.role === 'ADMIN' && ' (Admin)'}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {member.email}
//                     </Typography>
//                   </Box>

//                   {member.role !== 'ADMIN' && (
//                     <IconButton color="error" onClick={() => removeMember(member.user)}>
//                       <DeleteIcon />
//                     </IconButton>
//                   )}
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </CardContent>

//         {/* FOOTER */}
//         <Box p={2} borderTop="1px solid #eee">
//           <Button variant="contained" fullWidth disabled={loading} onClick={onSaveClicked}>
//             {loading ? <CircularProgress size={22} /> : 'Save Changes'}
//           </Button>
//         </Box>
//       </Card>
//     </Box>
//   ) : (
//     <ChatCreation method="add_to_group" chatRoomId={chatRoomId} userIds={userIds} />
//   );
// };

// export default GroupDetails;

import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Avatar,
  Button,
  Grid,
  IconButton,
  Divider,
  CircularProgress,
  Stack,
  Icon,
  Paper,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import chatApi from './ChatApi';
import { chatPhotoUrl, uploadedFileUrl } from '../../utils/constants/links';
import ChatCreation from './ChatCreation';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Snackbar, Alert } from '@mui/material';
import GroupDetailsSkeleton from './GroupSkeleton';
import { commonFileUpload } from '../../redux/features/assetManagementSlice';
import { useDispatch } from 'react-redux';

const GroupDetails = ({ chatDetails, onBack, getChatList, handleBackToList }) => {
  const chatRoomId = chatDetails?.chat_room_id;
  const profile = JSON.parse(localStorage.getItem('cred'))?.profile;

  // ⚠️ Pass current user id from parent / auth
  const currentUserId = profile?.userId;

  const [pageType, setPageType] = useState('grpDetails');
  const [allData, setAllData] = useState(null);
  const [groupName, setGroupName] = useState('');
  const [description, setDescription] = useState('');
  const [avatar, setAvatar] = useState(null);
  const [members, setMembers] = useState([]);
  const [userIds, setUserIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const dispatch = useDispatch();

  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  useEffect(() => {
    getGroupInfoDetails();
  }, []);

  const afterAddmemberToGroupThenBack = () => {
    setPageType('grpDetails');
    getGroupInfoDetails();
    getChatList();
  };
  const showAlert = (message, severity = 'success') => {
    setAlert({ open: true, message, severity });
  };

  const getGroupInfoDetails = async () => {
    setPageLoading(true);
    const res = await chatApi.getGroupInfo(chatRoomId);
    const data = res?.data;

    if (data) {
      setAllData(data);
      setGroupName(data.name);
      setDescription(data.description);
      setAvatar(data.profile_pic);
      setMembers(data.chatRoomMembers);

      const ids = data.chatRoomMembers.map((m) => m.user);
      setUserIds(ids);

      const me = data.chatRoomMembers.find((m) => m.user === currentUserId);
      setIsAdmin(me?.role === 'ADMIN');
    }
    setPageLoading(false);
  };

  const uploadFile = async (e) => {
    try {
      setLoading(true);
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('uploads', file);
      const response = await dispatch(commonFileUpload(formData));
      setAvatar(response.payload?.data?.filename || null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const removeMember = async (userId) => {
    await chatApi.removeMemberFromGroup(chatRoomId, userId);
    showAlert('Member removed successfully');
    getGroupInfoDetails();
    getChatList(); //COMMENT IF SOCKET WORKING MEMBER REMOVE NOTIFY
  };

  const onSaveClicked = async () => {
    setLoading(true);
    await chatApi.updateGroup({
      chatRoomId,
      groupName,
      profile_pic: avatar,
      description,
    });
    setLoading(false);
    showAlert('Group updated successfully');
    getGroupInfoDetails();
    getChatList(); //COMMENT IF SOCKET WORKING GROUP INFO UPDATE NOTIFY
  };

  const groupDelete = async () => {
    await chatApi.deleteGroup(chatRoomId);
    showAlert('Group deleted successfully');
    getChatList();
    handleBackToList();
  };

  const leaveFromGroup = async () => {
    await chatApi.leaveGroup(chatRoomId);
    showAlert('Group left successfully');
    getChatList(); //COMMNET IF SOCKET WORKING MEMBER LEAVE NOTIFY
  };

  return pageType === 'grpDetails' ? (
    pageLoading ? (
      <GroupDetailsSkeleton />
    ) : (
      <Box  height="100vh" display="flex" justifyContent="center" bgcolor="#f4f6f8">
        <Card sx={{ width: 900, height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* HEADER */}
          <Box
            sx={{
              px: 2,
              py: 2,
              backgroundImage: `url("/static/illustrations/chatTop.png")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: 0,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
              }}
            >
              {/* LEFT: Back button (fixed) */}
              <Box
                sx={{
                  width: 40,
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <IconButton
                  onClick={() => onBack({ reload: false })}
                  sx={{
                    color: '#fff',
                    bgcolor: 'rgba(0,0,0,0.4)',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' },
                  }}
                >
                  <ArrowBackIcon sx={{ color: '#fff', fontSize: 26 }} />
                </IconButton>
              </Box>

              {/* MIDDLE: Avatar */}
              <Box position="relative">
                <Avatar src={`${uploadedFileUrl}/${avatar}`} sx={{ width: 72, height: 72 }} />

                {isAdmin && (
                  <label htmlFor="group-avatar">
                    <input hidden id="group-avatar" type="file" onChange={uploadFile} />
                    <IconButton
                      component="span"
                      size="small"
                      sx={{
                        position: 'absolute',
                        bottom: -4,
                        right: -4,
                        bgcolor: '#fff',
                        boxShadow: 1,
                      }}
                    >
                      <AddAPhotoIcon fontSize="small" />
                    </IconButton>
                  </label>
                )}
              </Box>

              {/* RIGHT: Text */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                {isAdmin ? (
                  <TextField
                    variant="standard"
                    fullWidth
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    InputProps={{
                      sx: {
                        fontSize: 22,
                        fontWeight: 600,
                        color: '#fff',
                      },
                    }}
                  />
                ) : (
                  <Typography fontSize={22} fontWeight={600} color="white" noWrap>
                    {groupName}
                  </Typography>
                )}

                <Typography variant="caption" sx={{ color: '#d0d0d0' }}>
                  Created by <b>{allData?.created_by === currentUserId ? 'You' : allData?.createdBy}</b> •{' '}
                  {allData?.created_at}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* CONTENT */}
          <CardContent sx={{ flex: 1, overflowY: 'auto' }}>
            <Typography fontWeight={600}>Description</Typography>

            {isAdmin ? (
              <TextField
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                sx={{ mt: 1 }}
              />
            ) : (
              <Typography sx={{ mt: 1 }} color="text.secondary">
                {description || 'No description'}
              </Typography>
            )}

            {/* <Divider sx={{ my: 1 }} /> */}

            {/* MEMBERS */}
            {/* <Paper elevation={1} sx={{ my: 1 ,px:2, py:1}}> */}
            <Box
              p={1.5}
              sx={{ borderRadius: 2, border: '1px solid #e0e4e8' }}
              my={1}
              display="flex"
              justifyContent="space-between"
              alignItems={'center'}
            >
              <Typography variant="h6">Members ({members.length})</Typography>

              {isAdmin && (
                <IconButton onClick={() => setPageType('add_to_group')}>
                  <AddIcon />
                </IconButton>
              )}
            </Box>
            {/* </Paper> */}

            <Grid container spacing={2}>
              {members.map((member, index) => (
                <Grid item xs={12} key={`${member.user}-${index}`}>
                  <Card sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                    <Avatar src={`${chatPhotoUrl}/${member.photo}.jpg`} sx={{ mr: 2 }}>
                      {member.name?.charAt(0)}
                    </Avatar>

                    <Box flex={1}>
                      <Typography fontWeight={600}>
                        {member.name} {member.role === 'ADMIN' && '(Admin)'}
                      </Typography>
                      <Typography variant="caption">{member.email}</Typography>
                    </Box>

                    {isAdmin && member.role !== 'ADMIN' && (
                      <IconButton color="error" onClick={() => removeMember(member.user)}>
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Card>
                </Grid>
              ))}
            </Grid>
          </CardContent>

          {/* FOOTER */}
          {isAdmin ? (
            <Box p={2} borderTop="1px solid #eee">
              <Button
                fullWidth
                sx={{
                  backgroundColor: '#620a99',
                  boxShadow: 'none',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#45036e',
                    boxShadow: 'none',
                  },
                }}
                disabled={loading}
                onClick={onSaveClicked}
              >
                {loading ? <CircularProgress size={22} /> : 'Save Changes'}
              </Button>

              <Button fullWidth color="error" variant="contained" sx={{ mt: 1, mb: 4 }} onClick={groupDelete}>
                Delete Group
              </Button>
            </Box>
          ) : (
            <Box p={2} borderTop="1px solid #eee">
              <Button fullWidth color="error" variant="outlined" sx={{ mt: 1, mb: 4 }} onClick={leaveFromGroup}>
                Leave Group
              </Button>
            </Box>
          )}
        </Card>
        <Snackbar
          open={alert.open}
          autoHideDuration={4000}
          onClose={() => setAlert({ ...alert, open: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert severity={alert.severity} onClose={() => setAlert({ ...alert, open: false })} sx={{ width: '100%' }}>
            {alert.message}
          </Alert>
        </Snackbar>
      </Box>
    )
  ) : (
    <ChatCreation
      method="add_to_group"
      chatRoomId={chatRoomId}
      userIds={userIds}
      afterAddmemberToGroupThenBack={afterAddmemberToGroupThenBack}
    />
  );
};

export default GroupDetails;
